<template>
  <div class="themes preview-wrapper"
    v-loading.fullscreen="isRequesting"
    element-loading-text="サーバーに問い合わせています">

    <template v-if="isInitialized">
      <div :class="['preview', previewSize]">

        <template v-for="type in ['navigation', 'sidebar', 'footer']">
          <template v-if="themes[type] && themes[type].id">
            <div :is="getComponentNameById(themes[type].id)"
              :component="themes[type]"
              :preview-size="previewSize"
              v-on:update="updateComponent(type, $event)"
              v-on:delete="deleteComponent(type)"></div>
          </template>
          <template v-else>
            <div :class="['area', 'area-' + type]" @click="selectType(type)">ここをクリックして{{ locale[type] }}コンポーネントを選択してください</div>
          </template>
          <template v-if="type ==='sidebar'">
            <div class="area area-contents">
              <span>コンテンツエリア</span>
              <template v-for="type in Object.keys(components)">
                <template v-if="themes[type] && themes[type].id">
                  <p class="area-contents-controller"
                    @click="deleteComponent(type)">{{ locale[type] }}コンポーネントの削除</p>
                </template>
              </template>
            </div>
          </template>
        </template>

      </div>
    </template>

    <el-dialog width="75%" :title="selected.title" :visible.sync="dialogComponentsVisible">
      <el-carousel :autoplay="false" type="card" height="200px">
        <el-carousel-item v-for="(component, i) in selected.components" :key="i">
          <div class="el-carousel__contents flex column justify-center items-center" @click="selectComponent(i)">
            <h3>{{ component.meta.title }}</h3>
            <p>{{ component.meta.description }}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>

    <el-dialog width="90%" title="テーマカラーの選択" :visible.sync="dialogThemeVisible">
      <el-form class="flex justify-between items-start">
        <div class="flex column justify-between items-center" style="width:300px">
          <div class="color-wrapper flex justify-center items-center">
            <div :class="['color-base', currentTheme === 'base' ? 'current' : '']" :style="getThemeInlineStyle('background-color', 'base')" @click="currentTheme = 'base'"><span class="color-span">ベースカラー</span></div>
            <div :class="['color-main', currentTheme === 'main' ? 'current' : '']" :style="getThemeInlineStyle('background-color', 'main')" @click="currentTheme = 'main'"><span class="color-span">メインカラー</span></div>
            <div :class="['color-accent', currentTheme === 'accent' ? 'current' : '']" :style="getThemeInlineStyle('background-color', 'accent')" @click="currentTheme = 'accent'"><span class="color-span">アクセントカラー</span></div>
          </div>
          <chrome-picker v-model="themes.colors[currentTheme]"></chrome-picker>
          <el-button type="primary" class="color-apply-button" @click="applyColorChanges">適用</el-button>
        </div>
        <div class="style-preview">
          <div>
            <template v-for="type in ['navigation', 'sidebar', 'footer']">
              <template v-if="themes[type] && themes[type].id">
                <div :is="getComponentNameById(themes[type].id)"
                  :component="themes[type]"
                  :preview-size="previewSize" :in-preview="true"
                  v-on:update="updateComponent(type, $event)"
                  v-on:delete="deleteComponent(type)"></div>
              </template>
              <template v-if="type ==='sidebar'">
                <div class="area area-contents short">
                  <span>コンテンツエリア</span>
                </div>
              </template>
            </template>
          </div>
        </div>
      </el-form>
    </el-dialog>

    <fab
      position="bottom-left"
      bg-color="#20a0ff"
      icon-size="small"
      main-icon="settings"
      :actions="fabActions"
      @skin="dialogThemeVisible = true"
      @native="previewSize = 'native'"
      @smartphone="previewSize = 'smartphone'"
      @tablet="previewSize = 'tablet'"
      @desktop="previewSize = 'desktop'"
      @save="saveThemes"></fab>

    <el-dialog width="50%" :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import FAB from 'vue-fab'
import cloneDeep from 'lodash/cloneDeep'
import FAB from '@/components/app/FAB'
import { Chrome } from 'vue-color'
import AppAPI from '@/api'
import RouteBase from '@/components/mixins/RouteBase'

export default {
  name: 'themes',
  mixins: [RouteBase],
  components: {
    fab: FAB,
    'chrome-picker': Chrome
  },
  data () {
    return {
      previewSize: 'native',
      currentTheme: 'base',
      components: {
        navigation: AppAPI.componentsArrayOfType('navigation'),
        sidebar: AppAPI.componentsArrayOfType('sidebar'),
        footer: AppAPI.componentsArrayOfType('footer')
      },
      // colors: AppAPI.colors,
      selected: {
        type: null, // One of 'navigation'/ 'sidebar' / 'footer'
        title: '',
        components: []
      },
      dialogComponentsVisible: false,
      dialogThemeVisible: false,
      locale: {
        navigation: 'ナビゲーション',
        sidebar: 'サイドバー',
        footer: 'フッター'
      }
    }
  },
  computed: {
    fabActions: function () {
      return [
        {name: 'skin', icon: 'colorize', tooltip: 'テーマカラーの選択'},
        {name: 'native', icon: 'devices', tooltip: 'ディスプレイサイズでプレビュー'},
        {name: 'smartphone', icon: 'smartphone', tooltip: 'スマホサイズでプレビュー'},
        {name: 'tablet', icon: 'tablet', tooltip: 'タブレットサイズでプレビュー'},
        {name: 'desktop', icon: 'desktop_mac', tooltip: 'デスクトップサイズでプレビュー'},
        {name: 'save', icon: 'sync', tooltip: 'テーマを保存'}
      ]
    }
  },
  methods: {
    /**
     * selected.componentsにコンポーネントのリストをセットする
     */
    selectType: function (type) {
      this.selected.type = type
      this.selected.title = `${this.locale[type]}コンポーネントの選択`
      this.selected.components = this.components[type]
      this.dialogComponentsVisible = true
    },

    /**
     * テーマカラーが変更されたらCSSをinjectしてダイアログを閉じる
     */
    applyColorChanges: function () {
      this.injectThemeColorsStyle()
      this.dialogThemeVisible = false
    },

    /**
     * １）各コンポーネントの編集が終わったら
     * ２）コンポーネントを選択したら
     * actionをdispatchしてWP Databaseと同期する
     */
    applyChanges: async function () {
      this.dialogThemeVisible = false

      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/themes/update', this.themes)
      this.isRequesting = false

      if (response.id) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    },

    /**
     * 各コンポーネントを更新したときの処理
     */
    updateComponent: function (type, updated) {
    },

    /**
     * 各コンポーネントを削除したときの処理
     */
    deleteComponent: function (type) {
      this.themes[type] = null
    },

    /**
     * ダイアログでカルーセルからコンポーネントを選択したら
     * タイプに合わせてthemesに入れる
     */
    selectComponent: function (index) {
      this.themes[this.selected.type] = null
      // 一度再描画させる必要がある
      // 再描画完了後にコンポーネントを入れ替える
      this.$nextTick(function () {
        this.themes[this.selected.type] = cloneDeep(this.selected.components[index])
        this.dialogComponentsVisible = false
      })
    },

    /**
     * themesをWP Databseと同期する
     */
    saveThemes: async function () {
      const layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!@/scss/style.scss`)
      const theme = this.getCssForThemeColors() + `body {background-color:${this.themes.colors.base.hex}}`
      this.themes.css = {layout, theme}

      console.log(this.getCssForThemeColors())

      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/themes/update', this.themes)
      this.isRequesting = false

      if (JSON.stringify(response) === JSON.stringify(this.themes)) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Themes created...')

    /**
     * navigationやfooterでpagesが必要になる
     * navigation/sidebar/footerコンポーネントが生成される前に
     * pagesを用意しておかないとrenderingできないため、requestThemesよりも
     * 前にpagesを取得しておく必要がある
     */
    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    try { await this.requestPages() } catch (error) { return false }
    try { await this.requestSettings() } catch (error) { return false }
    try { await this.requestThemes() } catch (error) { return false }
    this.isRequesting = false

    this.injectThemeColorsStyle()

    this.isInitialized = true
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

$color_scheme_width: 300px;
.area {
  width: 100%;
  text-align: center;
  padding: 100px 0;
  // &-header {background-color: #f3f3f3}
  &-navigation {background-color: #fafafa}
  &-sidebar {background-color: #f1f1f1}
  &-footer {background-color: #fcfcfc}
  &-contents {
    padding: 300px 0;
    border: 1px solid #ddd;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' style='fill:transparent; stroke:#ddd' %3E%3Cpath d='M100,0 L0,100 Z' /%3E%3C/svg%3E");
    background-repeat: repeat;
    &-controller {
      margin: 1.5em auto;
      border: 1px solid $--color-primary;
      border-radius: 40px;
      padding: 1em 0;
      width: 22em;
      background-color: #fff;
      color: $--color-primary;
      line-height: 1;
      &:hover {
        background-color: $--color-primary;
        color: #fff;
        transition: $--all-transition;
      }
    }
    &.short {
      padding: 30px 0;
    }
  }
}

.color {
  &-wrapper {
    margin: 4em 0 7em;
    border: 1px solid #ddd;
    width: $color_scheme_width;
  }
  &-base,
  &-main,
  &-accent {
    position: relative;
    height: 40px;
    &.current {
      font-weight: bold;
      color: #20a0ff;
      &:before,
      &:after {
        background-color: #20a0ff;
      }
    }
  }
  &-span {
    display: block;
    padding: 1em 0;
    width: 8em;
    position: absolute;
  }
  &-base {width: (0.7 * $color_scheme_width)}
  &-main {width: (0.25 * $color_scheme_width)}
  &-accent {width: (0.05 * $color_scheme_width)}
  &-base {
    &:before {
      content: "";
      width: 1px;
      height: 40px;
      position: absolute;
      left: 34px;
      bottom: -34px;
      background-color: #999;
      transform: rotate(-45deg);
    }
    &:after {
      content: "";
      width: 7em;
      height: 1px;
      position: absolute;
      left: 48px;
      bottom: -28px;
      background-color: #999;
    }
    .color-span {
      left: 53px;
      bottom: -42px;
    }
  }
  &-main {
    &:before {
      content: "";
      width: 1px;
      height: 40px;
      position: absolute;
      right: 36px;
      bottom: 34px;
      background-color: #999;
      transform: rotate(-45deg);
    }
    &:after {
      content: "";
      width: 8em;
      height: 1px;
      position: absolute;
      right: 50px;
      bottom: 68px;
      background-color: #999;
    }
    .color-span {
      right: 32px;
      bottom: 55px;
    }
  }
  &-accent {
    &:before {
      content: "";
      width: 1px;
      height: 91px;
      position: absolute;
      left: -29px;
      bottom: -78px;
      background-color: #999;
      transform: rotate(45deg);
    }
    &:after {
      content: "";
      width: 9em;
      height: 1px;
      position: absolute;
      left: -186px;
      bottom: -65px;
      background-color: #999;
    }
    .color-span {
      left: -176px;
      bottom: -78px;
    }
  }
  &-apply-button {
    margin-top: 2em;
  }
}

.style-preview {
  width: 100%;
  margin-left: 30px;
  position: relative;
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>

<doc>
```
this.themes = {
  navigation: {
    id: 1,
    html: "",
    css: "",
    meta: {...},
    contents: {...}
  },
  sidebar: {
    id: 2,
    html: "",
    css: "",
    meta: {...},
    contents: {...}
  },
  footer: {
    id: 3,
    html: "",
    css: "",
    meta: {...},
    contents: {...}
  }
}
```
</doc>



// WEBPACK FOOTER //
// src/components/routes/Themes.vue